module.exports = __webpack_public_path__ + "static/media/deadline.fc59c3ce.svg";